import {makeAutoObservable} from 'mobx'
import {DataObjectId} from 'yougile-model'
import {PageService} from '@extensions/page-service'

interface StickerPanelGlobalStoreState {
  boardId?: DataObjectId
  expanded: Map<DataObjectId, boolean>
  oneLineMaxHeight: number
}

export class StickerPanelGlobalStore {
  state: StickerPanelGlobalStoreState = {
    expanded: new Map(),
    oneLineMaxHeight: 0
  }

  constructor() {
    this.syncBoardId()

    makeAutoObservable(this, {}, {autoBind: true})
  }

  syncBoardId(): void {
    this.state.boardId = PageService.getCurrentBoard()?.id
    if (!this.state.expanded.has(this.state.boardId)) {
      this.state.expanded.set(this.state.boardId, false)
    }
  }

  setExpanded(value?: boolean): void {
    if (this.state.boardId) {
      this.state.expanded.set(
        this.state.boardId,
        value ?? !this.state.expanded.get(this.state.boardId)
      )
    }
  }

  togglePanel(): void {
    this.setExpanded()
  }

  setOneLineMaxHeight(value: number): void {
    this.state.oneLineMaxHeight = value
  }

  get expanded(): boolean | undefined {
    return this.state.boardId
      ? this.state.expanded.get(this.state.boardId)
      : false
  }
}

export const stickerPanelGlobalStore = new StickerPanelGlobalStore()
